import * as React from "react";
import DatePickerComponent from "../../ui/datepicker/DatePickerComponent";
import {Option} from "ts-option";
import {default as DropDownList, DropDownItem} from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import DateUtils from "../../../utils/DateUtils";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import moment = require("moment");

interface Props {
	/**
	 * Update custom field value action.
	 * @param {string} updatedValue
	 */
	updateCustomFieldValue: (updatedValue: string) => void;
	/**
	 * Remove custom field value action.
	 */
	removeCustomFieldValue: () => void;
	/**
	 * Date
	 */
	value: Option<moment.Moment>
	/**
	 * Label
	 */
	label: string
}

interface State {
	menuDropDownVisible: boolean,
	datePickerVisible: boolean
}

export default class DateDisplay extends React.PureComponent<Props, State> {

	selectedDateMenu: DropDownItem[] = [
		{id: DateDisplayAction.CHANGE, label: "Change"},
		{id: DateDisplayAction.REMOVE, label: "Remove"},
	];

	emptyDateMenu: DropDownItem[] = [
		{id: DateDisplayAction.CHANGE, label: "Change"},
	];

	constructor(props: Props) {
		super(props);
		this.state = {menuDropDownVisible: false, datePickerVisible: false};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
	}

	render() {
		return (
			<InfoModule icon={Icon.New}
						title={this.props.label}
						actionIcon={Icon.Overflow}
						onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={this.props.value.isDefined ? this.selectedDateMenu : this.emptyDateMenu}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.datePickerVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({datePickerVisible: false})}>
					<DatePickerComponent value={this.props.value} onChange={this.onDateChange} inline/>
				</DropDownWrapper>}
				<span className={"t-body"}>
					{this.props.value.map(v => v.format(DateUtils.DATE_FORMAT)).getOrElse("Not specified")}
					</span>
			</InfoModule>
		)
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})
	}

	onMenuItemSelect(item: DropDownItem) {
		switch (item.id) {
			case DateDisplayAction.CHANGE:
				this.setState({menuDropDownVisible: false, datePickerVisible: true});
				break;
			case DateDisplayAction.REMOVE:
				this.setState({menuDropDownVisible: false, datePickerVisible: false}, () => this.props.removeCustomFieldValue());
				break;

		}
	}

	onDateChange(date: Option<moment.Moment>) {
		this.setState({datePickerVisible: false},
			() => this.props.updateCustomFieldValue(date.map(d => d.format(DateUtils.ISO_DATE_FORMAT)).getOrElse('')))
	}
}

export enum DateDisplayAction {
	CHANGE = 'CHANGE',
	REMOVE = 'REMOVE'
}